import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "as-matches",
  ref: "scrollComponent"
}
const _hoisted_2 = { class: "as-league_title" }
const _hoisted_3 = { class: "as-match_competition" }
const _hoisted_4 = { class: "as-match__teams as-d-none as-d-lg-flex" }
const _hoisted_5 = { class: "as-match__team as-match__team--home" }
const _hoisted_6 = { class: "as-scoreboard" }
const _hoisted_7 = { class: "as-match__team as-match__team--away" }
const _hoisted_8 = { class: "as-match__ht as-d-none as-d-lg-flex" }
const _hoisted_9 = { class: "as-match__corner as-d-none as-d-lg-flex" }
const _hoisted_10 = { class: "as-match__yellow-goal as-d-none as-d-lg-flex" }
const _hoisted_11 = ["data-id"]
const _hoisted_12 = { class: "as-match__item--wrap" }
const _hoisted_13 = { class: "as-match__sm" }
const _hoisted_14 = { class: "as-match__label" }
const _hoisted_15 = { class: "as-match__label as-d-flex as-d-lg-none" }
const _hoisted_16 = { class: "as-match__scores as-match__teams" }
const _hoisted_17 = { class: "as-match__team as-match__team--home" }
const _hoisted_18 = { class: "as-match__team--name as-match__team-home-name" }
const _hoisted_19 = { class: "as-scoreboard" }
const _hoisted_20 = { class: "as-match__team as-match__team--away" }
const _hoisted_21 = { class: "as-match__team--name as-match__team-away-name" }
const _hoisted_22 = { class: "as-match__ht as-d-none as-d-lg-flex" }
const _hoisted_23 = { class: "as-match__corner as-d-none as-d-lg-flex" }
const _hoisted_24 = { class: "as-match__yellow-goal as-d-none as-d-lg-flex" }

import { computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";
interface IProps {
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MatchsSkeleton',
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);

return (_ctx: any,_cache: any) => {
  const _component_SvgSprite = _resolveComponent("SvgSprite")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SvgSprite),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
        return _createElementVNode("div", {
          key: index,
          class: _normalizeClass(`as-competition-wrapper as-competition-wrapper-${siteName.value}`)
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(SkeletonLoader, {
                width: "30px",
                height: "30px",
                mode: "circle",
                line: 1
              }),
              _createVNode(SkeletonLoader, {
                width: "130px",
                height: "20px",
                line: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(SkeletonLoader, {
                  width: "120px",
                  height: "20px",
                  line: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(SkeletonLoader, {
                  width: "50px",
                  height: "20px",
                  line: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(SkeletonLoader, {
                  width: "120px",
                  height: "20px",
                  line: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(SkeletonLoader, {
                width: "50px",
                height: "20px",
                line: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(SkeletonLoader, {
                width: "50px",
                height: "20px",
                line: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(SkeletonLoader, {
                width: "50px",
                height: "20px",
                line: 1
              })
            ])
          ]),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (index) => {
            return _createElementVNode("div", {
              key: index,
              "data-id": index,
              class: "as-match__item"
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(SkeletonLoader, {
                      width: "100px",
                      height: "20px",
                      line: 1
                    }),
                    _createVNode(SkeletonLoader, {
                      width: "100px",
                      height: "20px",
                      line: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(SkeletonLoader, {
                      width: "50px",
                      height: "20px",
                      line: 1
                    }),
                    _createVNode(SkeletonLoader, {
                      width: "50px",
                      height: "20px",
                      line: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(SkeletonLoader, {
                      width: "40px",
                      height: "40px",
                      mode: "circle",
                      line: 1
                    }),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(SkeletonLoader, {
                        width: "120px",
                        height: "20px",
                        line: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(SkeletonLoader, {
                      width: "50px",
                      height: "20px",
                      line: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(SkeletonLoader, {
                      width: "40px",
                      height: "40px",
                      mode: "circle",
                      line: 1
                    }),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(SkeletonLoader, {
                        width: "120px",
                        height: "20px",
                        line: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(SkeletonLoader, {
                    width: "50px",
                    height: "20px",
                    line: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(SkeletonLoader, {
                    width: "50px",
                    height: "20px",
                    line: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(SkeletonLoader, {
                    width: "50px",
                    height: "20px",
                    line: 1
                  })
                ])
              ])
            ], 8, _hoisted_11)
          }), 64))
        ], 2)
      }), 64))
    ], 512)
  ], 64))
}
}

})